module.exports = __webpack_public_path__ + "img/Misi Inconsistency - Icon Template.5d65089e.png";